var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4286 11.8644C21.4286 17.0128 17.2073 21.1864 12 21.1864C6.79274 21.1864 2.57143 17.0128 2.57143 11.8644C2.57143 6.71599 6.79274 2.54237 12 2.54237C17.2073 2.54237 21.4286 6.71599 21.4286 11.8644ZM18.471 21.8577C16.6039 23.042 14.3831 23.7288 12 23.7288C5.37258 23.7288 0 18.4169 0 11.8644C0 5.31187 5.37258 0 12 0C18.6274 0 24 5.31187 24 11.8644C24 15.1407 22.6569 18.1067 20.4853 20.2538L23.0909 22.8299C23.593 23.3264 23.593 24.1312 23.0909 24.6277C22.5888 25.1241 21.7747 25.1241 21.2726 24.6277L18.471 21.8577Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f9ff43b8.svg";
export { ForwardRef as ReactComponent };